<template>
  <v-card
    class="cookie-banner"
    :class="{ isMobile }"
    max-width="1100"
    max-height="500"
    v-if="bannerShow"
    elevation="10"
  >
    <div class="cookie-banner-cont">
      <v-btn depressed icon rounded @click="close" class="close-btn">
        <v-icon color="primary">mdi-close</v-icon>
      </v-btn>
      <v-card-title
        class="justify-space-between align-center cookie-header pa-0"
      >
        <div class="bold">Zarządzanie plikami cookies</div>
      </v-card-title>
    </div>
    <div class="cookie-banner-text">
      <v-card-text class="pa-5 pt-0 pb-7 pr-sm-8 pl-sm-8 cookie-text">
        <p>
          Wykorzystujemy pliki cookies aby zapewnić prawidłowe funkcjonowanie
          serwisu oraz analizować ruch na stronie. Niektóre z plików cookies są
          niezbędne do prawidłowego funkcjonowania strony, natomiast dzięki
          plikom analitycznym dbamy <span class="nobr">o wysoką</span> jakość
          <span class="nobr">i ciągle</span> udoskonalamy działanie naszego
          serwisu. Możesz zaakceptować wszystkie pliki cookies wraz
          <span class="nobr">z analitycznymi,</span> lub odrzucić te, które nie
          są niezbędne.
        </p>
        <p>
          Wyrażona zgoda jest dobrowolna <span class="nobr">i można</span> ją
          wycofać, dokonując zmiany
          <span class="nobr">w ustawieniach</span> przeglądarki lub
          <span class="nobr">
            w
            <router-link
              color="primary"
              class="bold"
              to="/polityka-prywatnosci"
            >
              polityce prywatności.</router-link
            >
          </span>
          Wycofanie zgody pozostanie bez wpływu na zgodność z prawem używania
          plików cookies, którego dokonano na podstawie zgody przed jej
          wycofaniem.
        </p>

        <div class="frame">
          <span class="bold">1. Niezbędne</span>
          <span> – wymagane do prawidłowego działania serwisu.</span>
        </div>
        <div class="frame">
          <span class="bold">2. Analityczne</span>
          <span>
            – pomagają nam analizować ruch na stronie i ulepszać jej działanie.
          </span>
        </div>
      </v-card-text>
      <v-card-text
        class="text-right pa-8 pt-0 pb-8"
        :class="{ 'text-center': $vuetify.breakpoint.smAndDown }"
      >
        <v-btn
          @click="reject"
          color="primary"
          class="mr-2 mt-0 mt-2"
          outlined
          rounded
          large
        >
          Akceptuj tylko niezbędne
        </v-btn>
        <!-- :small="isMobile" -->
        <v-btn
          @click="accept"
          color="primary"
          class="mr-2 mt-2"
          depressed
          rounded
          large
        >
          Akceptuj wszystkie
        </v-btn>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
let cookiesAccept = false;
let cookiesAcceptRejected = false;
let isClosed = false;

import {
  setCookisAccept,
  setCookisDenied,
  stopTracking,
} from "../util/cookie-accept";

export default {
  name: "CookieBanner",
  props: {},
  data: () => {
    return {
      bannerShow: false,
    };
  },
  mounted() {
    cookiesAcceptRejected = document.cookie.includes("cookies-accept=rejected");
    cookiesAccept = document.cookie.includes("cookies-accept");
    this.checkStatus();
    if (!cookiesAccept || cookiesAcceptRejected) {
      stopTracking();
    }
  },

  methods: {
    checkStatus() {
      if (!cookiesAccept && this.$route.name !== "PrivacyPolicy" && !isClosed) {
        this.bannerShow = true;
      } else {
        this.bannerShow = false;
      }
    },
    close() {
      this.bannerShow = false;
      isClosed = true;
    },
    accept() {
      setCookisAccept();
      this.bannerShow = false;
      cookiesAccept = true;
    },
    reject() {
      setCookisDenied();
      this.bannerShow = false;
      cookiesAcceptRejected = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.cookie-banner {
  z-index: 10;
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  overflow: auto;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  word-break: normal !important;

  .v-card__title {
    word-break: normal !important;
  }
}

.cookie-banner-text {
  flex-grow: 1;
  overflow: auto;
}
.close-btn {
  position: absolute;
  right: 18px;
  top: 17px;
}

.cookie-banner-cont {
  padding: 18px 50px 12px 20px;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.13);
  margin-bottom: 10px;
}

.frame {
  padding: 12px 24px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 8px;
}
.nobr {
  text-wrap: nowrap;
}

@media (width >= 600px) {
  .cookie-banner {
    display: block;
  }
  .cookie-banner-cont {
    padding: 32px 50px 19px 32px;
    box-shadow: none;
    margin-bottom: 0;
  }
  .close-btn {
    right: 22px;
    top: 30px;
  }
}
</style>
